export default  {"src":"/_next/static/image/public/assets/icons/search-black.bff2c70444eab082d79c6f7bb26641a3.svg","height":28,"width":28};